import { getClient } from '@zg-rentals/http-client';
import { logError } from '@zg-rentals/log-error';
import { getAnalyticsErrorType } from '@zg-rentals/rentals-analytics';
import { PAGEVIEW_CANDIDATE } from './constants';

export async function callComscoreApi(pageviewApi: string, onSuccess: () => void) {
  try {
    const client = getClient().extend({ prefixUrl: pageviewApi });
    const text = await client
      .get('comscore/get', {
        searchParams: {
          comscorekw: 'rentals',
        },
      })
      .text();
    if (!text.includes(PAGEVIEW_CANDIDATE)) {
      throw new Error(`Comscore API returned unexpected response: ${text}`);
    }
    onSuccess();
  } catch (error) {
    logError({
      error,
      errorType: getAnalyticsErrorType('ComscoreAPIError'),
    });
  }
}
